/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface WebhookRequest {
    orcidId: string;
}

/**
 * 
 */
export class PublicApi extends runtime.BaseAPI {

    /**
     * Creates request options for webhook without sending the request
     */
    async webhookRequestOpts(requestParameters: WebhookRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling webhook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/public/{orcid_id}/updated`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get notifications of ORCID profile updates for the given ORCID iD (using webhooks).
     */
    async webhookRaw(requestParameters: WebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.webhookRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get notifications of ORCID profile updates for the given ORCID iD (using webhooks).
     */
    async webhook(requestParameters: WebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.webhookRaw(requestParameters, initOverrides);
    }

}
